import React from 'react'
import PhoneNumber, { PhoneNumberData } from 'phone-number'
import { Typography } from 'foundations-library/components'
import { makeStyles } from '@material-ui/core'
import { FilterOptions } from './Header'

const useStyles = makeStyles(theme => {
    const { colors } = theme['foundations-library']

    return {
        recommendedNumberSection: {
            display: 'flex',
            height: '84px',
            padding: '4px 4px 4px 20px',
            alignItems: 'center',
            gap: '40px',
            alignSelf: 'stretch',
            borderRadius: '10px',
            border: `1px solid ${colors.primary[300]}`,
            marginTop: ({ showTypeSelector, showAreaCodeSelector, showKeywordSelector }) => showTypeSelector && !showAreaCodeSelector && !showKeywordSelector ? '120px' : '0px',
            '& .neutral-900-color': {
                color: colors.neutral[900]
            },
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                gap: '6px',
                height: 'auto',
                padding: '4px 20px'
            }
        },
        textContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '4px',
            flex: '1 0 0',
            [theme.breakpoints.down('sm')]: {
                '& .text': {
                    margin: 'auto'
                }
            }
        },
        phoneNumberContainer: {
            display: 'flex',
            width: '210px',
            height: '76px',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '8px',
            backgroundColor: colors.primary[200],
            padding: '24px 0',
            gap: '8px',
            '& .calls-icon': {
                width: '28px',
                height: '28px'
            }
        }
    }
})

interface Props {
    phoneNumber: PhoneNumberData;
    numberBeingSelected: PhoneNumberData | null;
    onNumberClick: () => void;
    filters: FilterOptions[];
}

/**
 * Prominently displays a particular number, recommending it.
 */
const RecommendedNumberSection = (props: Props): JSX.Element => {
    const showTypeSelector = props.filters.some(filter => filter.name === 'NumberType')
    const showAreaCodeSelector = props.filters.some(filter => filter.name === 'AreaCode')
    const showKeywordSelector = props.filters.some(filter => filter.name === 'KeywordSearch')

    const classes = useStyles({ showTypeSelector, showAreaCodeSelector, showKeywordSelector })

    return (
        <div className={classes.recommendedNumberSection}>
            <div className={classes.textContainer}>
                <Typography variant="subtitle1" className={'neutral-900-color text'}>Go local with this personalized number:</Typography>
                <Typography variant="body2" className={'neutral-900-color text'}>Or choose a different number below.</Typography>
            </div>
            <PhoneNumber
                isNumberTaken={false}
                testId={props.phoneNumber.e164}
                isRecommended={true}
                phoneNumber={props.phoneNumber}
                numberBeingSelected={props.numberBeingSelected}
                onClick={() => props.onNumberClick()}
            />
        </div>
    )
}

export default RecommendedNumberSection
